 /**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

 import { defaultNullValue } from 'src/config';
 import Api from 'src/util/api';
 import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
 
export declare namespace AuthConfigDOI {
     export interface RowDataI {
         mn: string;
         sim: string;
         status: number;
         id: number;
     }
 
     export interface QueryRowDataParamsI extends PageDo {
     }

     export interface FormDataI {
        mn: string;
        sim: string;
     }
}


export default class AuthConfigApi {
     /**
      * 查询列表
      * @param {GetPeopleManageListParamsI} params
      * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
      */
     static async searchList(params: AuthConfigDOI.QueryRowDataParamsI): Promise<ResultPageDo<AuthConfigDOI.RowDataI[]>> {
         return Api.post('/monitor/select/mn_sim', {
            ...params,
         });
     }

     static async add(data:AuthConfigDOI.FormDataI):Promise<Result<any>> {
		return Api.post('/monitor/add/mn_sim', data)
	 }

    static async delete(id: Integer):Promise<Result<any>> {
		return Api.post('/monitor/delete/mn_sim', {id})
    }

 }
 